import * as actions from './actions';
import * as getters from './getters';
import AuthService from '../../../services/AuthService';
import router from '../../../router';

import { LOG_IN, LOG_OUT, REFRESH_ACCESS_TOKEN } from './mutation-types';

const initialState = {
    user: AuthService.isUserAuthenticated() ? AuthService.getPayload() : {}
};

const mutations = {
    [LOG_IN](state, tokens) {
        AuthService.authenticateUser(tokens);
        state.user = AuthService.getPayload();
        router.push('/');
    },

    [LOG_OUT](state) {
        AuthService.deauthenticateUser();
        state.user = {};
    },
    [REFRESH_ACCESS_TOKEN](state, tokens) {
        AuthService.setAccessToken(tokens.accessToken);
        AuthService.setRefreshToken(tokens.refreshToken);
        state.user = AuthService.getPayload();
    }
};

export default {
    state: {
        ...initialState
    },
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js